import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { BackofficeService } from "../../services/backoffice.service";
import {
  closeAlertAction,
  showAlertAction,
} from "../../store/actions/alert.action";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { IAppState } from "../../store/state/app.state";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { merge, Observable, of as observableOf } from "rxjs";
import { catchError, map, startWith, switchMap } from "rxjs/operators";
import { iconsLibrary } from "../../../theme/constants";
import { MatTableDataSource } from "@angular/material/table";
import * as moment from "moment";
@Component({
  selector: "cowing-core-backoffice-users",
  templateUrl: "./backoffice-users.component.html",
  styleUrls: ["./backoffice-users.component.scss"],
})
export class BackofficeUsersComponent implements AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  resultsLength: any;

  constructor(
    private _store: Store<IAppState>,
    private translate: TranslateService
  ) {}
  public displayedColumns: string[] = [];
  public dataSource = null;
  private buildUser(data) {
    return {
      id: data.id,
      name: data.name,
      phone: data.phone,
      admin: data.admin,
      company_group_id: data.company_group_id,
      company_id: data.company_id,
      coworker_id: data.coworker_id,
      coworking_group_id: data.coworking_group_id,
      coworking_id: data.coworking_id,
      created_at: data.created_at,
      updated_at: data.updated_at,
    };
  }
  dateFormatedLong(date) {
    return moment(date).lang("es").format("DD/MM/YYYY HH:mm");
  }
  async ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this._store.dispatch(showLoadingAction({}));
          return BackofficeService.instance.getUsers({
            page: this.paginator.pageIndex,
            pageSize: this.paginator.pageSize,
          });
        }),
        map((data) => {
          this._store.dispatch(closeLoadingAction({}));
          this.resultsLength = data.total_elements;
          return data["users"];
        }),
        catchError((e) => {
          this._store.dispatch(
            showAlertAction({
              payload: {
                message: e.error,
                title: this.translate.instant("general.caution"),
                type: "error",
              },
            })
          );
          this._store.dispatch(closeLoadingAction({}));
          return observableOf([]);
        })
      )
      .subscribe((data) => {
        const dataFiltered = data.map((user) => this.buildUser(user));
        if (!this.displayedColumns.length) {
          this.displayedColumns = Object.keys(dataFiltered[0]);
          this.displayedColumns.push("actions");
        }
        this.dataSource = new MatTableDataSource(dataFiltered);
      });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  public editUser(company) {
    //   this._store.dispatch(
    //     showAlertAction({
    //       payload: {
    //         message: null,
    //         title: null,
    //         type: "editCompany",
    //         editCompanyId: company.id,
    //       },
    //     })
    //   );
  }

  public deleteUser(company) {
    //   this._store.dispatch(
    //     showAlertAction({
    //       payload: {
    //         message: "",
    //         title: "Â¿Desea eliminar esta compaÃ±ia?",
    //         type: "deleteCompany",
    //         deleteCompanyId: company.id,
    //       },
    //     })
    //   );
  }

  public get getEditIcon() {
    return `${iconsLibrary.editBackoffice}`;
  }
  public get getDeleteIcon() {
    return `${iconsLibrary.trashBackoffice}`;
  }
}
